// these are all STAGING currently - add staging/prod
function getEndpoint() {
  switch (process.env.REACT_APP_CUSTOMER) {
    case 'frs':
      return 'https://6dn12v6b11.execute-api.us-east-1.amazonaws.com';
    case 'trindco':
      return 'https://darqdv6r5a.execute-api.us-east-1.amazonaws.com';
    case 'tcf':
      return 'https://4b9vbmb9el.execute-api.us-east-1.amazonaws.com';
    case 'simple':
      return 'https://txvteiy2ll.execute-api.us-east-1.amazonaws.com'; // staging
    case 'dev':
      return 'https://zlg86abr7i.execute-api.us-east-1.amazonaws.com'; // dev
    default:
      throw new Error('REACT_APP_CUSTOMER not set or unknown');
  }
}

export const endpointOwlApc = getEndpoint();
